import LabelAnnotation from './LabelAnnotation';
import { gConsts } from '@/globals/gConsts';


/**
 * Node do relatório.
 */
export default class ReportNode {

    /**
     * @param {string} id
     * @param {{index: number}} order
     * @param {{parent: string, type: string, color: string | undefined, caption: string}} layout
     * @param {{type: string, list: LabelAnnotation[]}} annotation
     * @param {string} reportText
     * @param {{insertionType: 'manual' | 'auto', validated: boolean}} info
     */
    constructor(id, order, layout, annotation = {type: null, list: []}, reportText = '', info = { insertionType: 'manual', validated: true }) {
        /** @type {number} */
        this.id = id;
        /** @type {{index: number}} */
        this.order = order;
        /** @type {{parent: string, type: string, color: string | undefined, caption: string}} */
        this.layout = layout;
        /** @type {{type: string, list: LabelAnnotation[]}} */
        this.annotation = annotation;
        /** @type {string} */
        this.reportText = reportText;
        /** @type {{insertionType: 'manual' | 'auto', validated: boolean}} */
        this.info = info;
    }

    /**
     * @param {Object} object
     * @returns {ReportNode}
     */
    static fromObject(object) {
        if (!object)
            return null;
        const annotationList = object?.annotation?.list?.map(annotation => LabelAnnotation.fromObject(annotation)) || [];
        const reportNode = new ReportNode(object.id, object.order, object.layout, {type: object.annotation.type, list: annotationList}, object.reportText, object.info);
        return reportNode;
    }

    toObject() {
        return JSON.parse(JSON.stringify(this));
    }

    get isLabel() {
        return this.layout.type === gConsts.node.layout.types.LABEL;
    }

    get isValidated() {
        return this.info?.validated ?? false;
    }

    get isCustomLine() {
        return this.layout.type === gConsts.node.layout.types.CUSTOM_LINE;
    }

    get canHaveAnnotations() {
        if (!this.isLabel)
            return false;
        return this.annotation.type !== null && this.annotation.type !== gConsts.node.report.annotation.types.FIXED;
    }

}